module.exports = __webpack_public_path__ + "static/img/zfb.6c5740b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/zfb.png
// module id = Zx4y
// module chunks = 1